import { createEntityAdapter, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { server} from "../staticData/staticData";
import * as Sentry from "@sentry/react";
const driverAdapter=createEntityAdapter();
const initialState=driverAdapter.getInitialState({});
const serverURL=server
export const getDriverById=createAsyncThunk('driver/getdriverbyid', async ({id,token})=>{
     const config={
        headers: {'x-api-key': `${token}`}
    }
    try {
        const response=await axios.get(serverURL+"drivertempcheck/driver/"+id,config);
        return response.data;   
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error getDriverById, driverId:" +id);
    }
})

const driverSlice=createSlice({
    name:'driver',
    initialState,
    reducers:{},
    extraReducers: (builder)=>{
        builder.addCase(getDriverById.fulfilled,(state,action)=>{
            state.status="success"
            state.entities.currDriver=action.payload;
        })
        .addCase(getDriverById.pending, (state,action)=>{
            state.status="pending"
        })
        .addCase(getDriverById.rejected, (state,action)=>{
            state.status="idle"
        })
    }
})
export default driverSlice.reducer;